import * as React from 'react';
import { AppCtx } from '../mixin/app_context';
import { Col, Row } from 'deda-rkit';
import { Link } from 'react-router-dom';
import { getScene, pathRedirect } from '../mixin/functions';
import { TViewsState } from '../mixin/types';
import { IApiClient } from '../http_client/api_client';

type BoxGuideTecnicheProps = {
  apiClient: IApiClient;
  updateLoader: (boolean) => void;
}

export default class BoxGuideTecniche extends React.Component<BoxGuideTecnicheProps, TViewsState>{
    context!: React.ContextType<typeof AppCtx>
    static contextType = AppCtx;

    constructor(props) {
      super(props);
      this.state = {
        scene: {guide_tecniche_presenti : false},
        flash: null,
      };
    }

  componentDidMount(): void {
    const promise = getScene(this.props.apiClient, '/portal/guide_tecniche', this.props.updateLoader);

    promise.then((spiderScene) => {
      if(spiderScene.dati?.url_redirect){
        this.props.updateLoader(true); /* attivo loader */
        /* setto url_servizio per effettuare redirect con navigate */
        this.setState({url_servizio: "/portal/"+pathRedirect(spiderScene.dati.url_redirect), flash: spiderScene.flash});
      }else{ /* set scene generale */
        //this.setState({scene: responseApi.dati, flash: responseApi.flash});
        console.log(spiderScene);

        let objGuide = {
          guide_tecniche_presenti: false
        }

        if (spiderScene.esito === 'ok') {
          objGuide.guide_tecniche_presenti = spiderScene.dati.guide_tecniche.length > 0;
        }
         
        let newSceneObj: any = { scene: {...objGuide}, flash: spiderScene.flash };
        
         /* set scene generale facendo il merge delle due response*/
          newSceneObj = {...newSceneObj};
          this.setState(newSceneObj);


      }
    })
  }



  render(){

    
    return(
      <Row className='bg-box-guide-tecniche justify-content-center text-center text-white mx-0'>
        <Col lg='6' className='p-4'>
          <h2>Hai bisogno di aiuto?</h2>
          <p>
            {
              this.state.scene.guide_tecniche_presenti && (
                <>
                  Consulta le <Link to='/portal/guide_tecniche' className='text-white fw-bold'>guide tecniche</Link> oppure
                </>
              )
            } Contatta l'Ente per avere ulteriori informazioni dal servizio di Assistenza.
          </p>
          <span className='fw-bold'>{this.context?.confEnte.mail}</span>
        </Col>
      </Row>
    );
  }
}
